import { createFileRoute } from '@tanstack/react-router';
import { MessageManager } from '../../components/admin/MessageManager';

export const Route = createFileRoute('/admin/messages')({
  component: MessagesTab,
});

function MessagesTab() {
  return <MessageManager />;
}
